import { ClickAwayListener } from "@mui/base/ClickAwayListener";
import { Box, Menu, MenuItem, Tooltip } from "@mui/material";
import { State, process as kendoProcess } from "@progress/kendo-data-query";
import {
  GridColumn,
  GridContextMenuEvent,
  GridDataStateChangeEvent,
  GridDetailRowProps,
  GridEvent,
  GridExpandChangeEvent,
  GridHeaderCellProps,
  GridRowClickEvent,
} from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import DetailComponent from "./components/DetailComponent";
import Footer from "./components/Footer";
import HeaderPlano from "./components/HeaderPlano";
import "./style.css";
import GenericModal from "./modals/GenericModal";
import StatsModalComponent from "./components/StatsModalComponent";
import { getModalStyle } from "../modalStyle";
import {
  planoAPI,
  useGetActivitesQuery,
  useGetBannieresQuery,
  useGetCollectionsQuery,
  useGetDivisionsQuery,
  useGetFooterQuery,
  useGetFournisseursQuery,
  useGetMagasinsQuery,
  useGetPlanogrammeQuery,
  useGetSectionsQuery,
  useGetStatutQuery,
  useGetUsersQuery,
  useLazyGetPlanoQuery,
} from "../../redux/features/cache";
import { Division } from "../../models/Division";
import { Magasin } from "../../models/Magasin";
import { Banniere } from "../../models/Banniere";
import { Activite } from "../../models/Activite";
import { User } from "../../models/User";
import FormNewProduit from "./components/Forms/FormNewProduit";
import GridWrapper from "../grid/GridWrapper";
import WrapperEditMagasin from "./components/WrapperEditMagasin";
import { addNotificationMessages } from "../../redux/features/appStateSlice";
import WrapperMagasin from "./components/WrapperMagasin";
import { padZerosLeft } from "../../commons/helpers/StringHelper";
import { PTR_LENGTH } from "../../constante/produits";
import { headers } from "../../constante/planoGoupeHeader";
import { GroupProduit } from "../../models/GroupProduit";
import { Section } from "../../models/Section";
import { formatDate } from "../../constante/generic";
import { Statut } from "../../models/Statut";
import { APIError } from "../../errors/APIError";
import CustomGrid from "../grid/CustomGrid";
import sizeConfigs from "../../configs/sizeConfigs";
import Toolbar from "./components/Toolbar";
import { getParamValue } from "../../commons/helpers/ObjectHelper";
import { Fournisseur } from "../../models/Fournisseur";
import { Keys } from "../../constante/keys";
import { UrlParams } from "../../constante/UrlParams";
import useUrlParamsHandler from "../../hooks/useUrlParamsHandler";
import { mapTree } from "@progress/kendo-react-common";
import { Collection } from "../../models/Collection";
import useGetPollingInterval from "../../hooks/useGetPollingInterval";
import { ResponseTypes } from "../../constante/responseTypes";

function PlanogrammePage() {
  const sortableFields = useMemo(
    () => [
      "div_nom",
      "plans_seq",
      "mod_descr",
      "prod_num",
      "four_nom",
      "act_cd",
      "prod_collection",
      "planost_ventes",
      "planost_ventes_mcx",
    ],
    []
  );
  const urlParamsHandler = useUrlParamsHandler();
  const [user, setUser] = useState<string>(
    urlParamsHandler.getParams(UrlParams.Acheteur)
  );
  const [ban, setBan] = useState<string>(
    urlParamsHandler.getParams(UrlParams.Banniere)
  );
  const [mag, setMag] = useState<string>(
    urlParamsHandler.getParams(UrlParams.Magasin)
  );
  const [div, setDiv] = useState<string>(
    urlParamsHandler.getParams(UrlParams.Division)
  );
  const [section, setSection] = useState<string>(
    urlParamsHandler.getParams(UrlParams.Section)
  );
  const [four, setFour] = useState<string>(
    urlParamsHandler.getParams(UrlParams.Fournisseur)
  );
  const [currentAcc, setCurrentAcc] = useState<string>(
    urlParamsHandler.getParams(UrlParams.Activite)
  );
  const [statut, setStatut] = useState<string>(
    urlParamsHandler.getParams(UrlParams.Statut)
  );
  const [collection, setCollection] = useState<string>(
    urlParamsHandler.getParams(UrlParams.Collection)
  );
  const [rech, setRech] = useState<string>(urlParamsHandler.getParams("rech"));
  const dispatch = useAppDispatch();
  const [listMags, setListMags] = useState<Magasin[]>([]);
  const [page, setPage] = useState<number>(1);
  const [pageSize] = useState<number>(100);
  const [open, setOpen] = useState(false);
  const [openNewProduit, setOpenNewProduit] = useState<boolean>(false);
  const [openRemplacePar, setOpenRemplacePar] = useState<boolean>(false);
  const [toSort, setToSort] = useState<string>("");
  const [order, setOrder] = useState<string>("");
  const handleCloseNewProduit = () => {
    setOpenNewProduit(false);
    setAddProductTitle("");
    setAnchorEl(null);
    dispatch(planoAPI.util.invalidateTags(["planogramme", "plano"]));
  };
  const [openModalStats, setOpenModalStats] = useState(false);
  const handleCloseModalStats = () => {
    setSelectedRow(null);
    setOpenModalStats(false);
    setAnchorEl(null);
  };
  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };
  const [activeSectionNum, setActiveSectionNum] = useState<number>(0);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMod = Boolean(anchorEl);
  const [prev, setPrev] = useState<number>(0);
  const [showAddMagasinMenu, setShowAddMagasinMenu] = useState(false);
  const [showAddMagasin, setShowAddMagasin] = useState(false);
  const buttonsState = useAppSelector((state) => state.appState.buttonsState);
  const headerExpanded = useAppSelector(
    (state) => state.appState.planoHeaderExpanded
  );
  const [fields, setProductFields] = useState<string | undefined>(
    buttonsState.productView ? "div_nom,plans_nom" : "div_nom,plans_nom,mag_nom"
  );
  const [mode, setMode] = useState(buttonsState.productView ? "" : "MagProd");
  const [activeMagasin, setActiveMagasin] = useState("");
  const [activeMagasinNum, setActiveMagasinNum] = useState(0);
  const [collapsedGroups, setCollapsedGroups] = useState<string[]>([]);
  const [openModalEdit, setOpenModalEdit] = useState<boolean>(false);
  const pollingInterval = useGetPollingInterval();
  const modalOpened = useAppSelector((state) => state.appState.modalsOpened);
  const initialdataState: State = useMemo(() => {
    return {
      group: fields
        ?.split(",")
        .map((item) => ({ field: item, dir: undefined })),
    };
  }, [fields]);

  const {
    data: planogrammes = [] as GroupProduit[],
    isFetching,
    isLoading,
    isError,
    error,
  } = useGetPlanogrammeQuery(
    {
      first: fields,
      mag,
      banniere: ban,
      section,
      four,
      div,
      page,
      rech,
      limite: pageSize,
      acht: user,
      act: currentAcc,
      toSort,
      order,
      statut,
      mode,
      coll: collection,
    },
    { pollingInterval: pollingInterval }
  );
  const groupProduit = planogrammes;
  const d_inv01rp = useAppSelector((state) => state.appState.d_inv01rp);
  const d_inv170 = useAppSelector((state) => state.appState.d_inv170);
  const { data: divisions = [] as Division[] } = useGetDivisionsQuery({
    treeView: true,
    includeSections: true,
    user: user,
    plano: true,
  });
  const { data: magasins = [] as Magasin[] } = useGetMagasinsQuery({
    banniere: "",
    treeView: true,
  });
  const { data: bannieres = [] as Banniere[] } = useGetBannieresQuery({
    InclMag: false,
    treeView: true,
  });
  const { data: activites = [] as Activite[] } = useGetActivitesQuery(true);
  // const { data: footer = { plans_seq: 0, nbVise: "0/0", ptrCount: "0" } } =
  //   useGetFooterQuery({
  //     plan: activeSectionNum,
  //     first: fields,
  //     mag: buttonsState.storeView ? activeMagasinNum.toString() : mag,
  //     banniere: ban,
  //     section,
  //     four,
  //     div,
  //     page,
  //     rech,
  //     limite: pageSize,
  //     acht: user,
  //     act: currentAcc,
  //     toSort,
  //     order,
  //     statut,
  //   });
  const { data: users = [] as User[] } = useGetUsersQuery({
    fonction: "Plano",
    sort: "usr_nom",
    div_num: div,
  });
  const { data: sections = [] as Section[] } = useGetSectionsQuery({
    div,
    simple: true,
    user: "",
    rech: "",
    treeView: true,
  });
  const { data: statuts = [] as Statut[] } = useGetStatutQuery(true);
  const { data: fournisseurs = [] } = useGetFournisseursQuery({
    withMod: "true",
    rech: "",
    treeView: true,
  });
  const { data: collections = [] } = useGetCollectionsQuery({
    four: "",
    mod: "",
    treeView: true,
  });

  const [trigger] = useLazyGetPlanoQuery();
  const [dataState, setDataState] = useState<State>(initialdataState);
  const [selectedRow, setSelectedRow] = useState<number | null>(null);
  const [activeSection, setActiveSection] = useState("");
  const [dataResult, setDataResult] = useState(
    kendoProcess(groupProduit, dataState)
  );
  const [unsaved, setUnsaved] = useState<boolean>(false);
  const [addProductTitle, setAddProductTitle] = useState<string>("");
  const acheteursSelected = useMemo(() => {
    return users.filter((u) => {
      let currentUsers = user.split(",");
      return currentUsers.includes(u.usr_cd);
    });
  }, [user, users]);
  const bannieresSelected = useMemo(() => {
    return bannieres.filter((e) => {
      let currentBannieres = ban.split(",");
      return currentBannieres.includes(e.maggrp_cd);
    });
  }, [ban, bannieres]);
  const magasinsSelected = useMemo(() => {
    return magasins.filter((e) => {
      let currentMagasins = mag.split(",");
      return currentMagasins.includes(e.mag_num.toString());
    });
  }, [mag, magasins]);
  const divisionsSelected = useMemo(() => {
    return divisions.filter((e) => {
      let currentDivisions = div.split(",");
      return currentDivisions.includes(e.div_num.toString());
    });
  }, [div, divisions]);
  const sectionsSelected = useMemo(() => {
    return sections.filter((e) => {
      let currentSections = section.split(",");
      return currentSections.includes(e.plans_seq.toString());
    });
  }, [section, sections]);
  const activitesSelected = useMemo(() => {
    return activites.filter((e) => {
      let currentActivites = currentAcc.split(",");
      return currentActivites.includes(e.act_cd.toString());
    });
  }, [activites, currentAcc]);
  const statutsSelected = useMemo(() => {
    return statuts.filter((e) => {
      let currentStatuts = statut.split(",");
      return currentStatuts.includes(e.statut_aff.toString());
    });
  }, [statut, statuts]);
  const fournisseursSelected = useMemo(() => {
    return fournisseurs.filter((e) => {
      let currentFournisseurs = four.split(",");
      return currentFournisseurs.includes(e.four_cd);
    });
  }, [four, fournisseurs]);
  const collectionsSelected = useMemo(() => {
    return collections.filter((e) => {
      let currentCollections = collection.split(",");
      return currentCollections.includes(e.prod_collection);
    });
  }, [collection, collections]);

  const resetPage = useCallback(() => {
    if (page > 1) setPage(1);
  }, [page, setPage]);

  const updateObject = useCallback(
    (
      object: any,
      currentValues: any[],
      key: string,
      update: any,
      name: string
    ) => {
      const newValue = getParamValue(currentValues, object, key);
      resetPage();
      update(newValue);
      urlParamsHandler.setParamsToUrl(name, newValue);
    },
    [resetPage, urlParamsHandler]
  );

  const bannieresChildren = useMemo(
    () => [
      (banniere: Banniere) =>
        updateObject(
          banniere,
          bannieresSelected,
          Keys.Banniere,
          setBan,
          UrlParams.Banniere
        ),
      (magasin: Magasin) =>
        updateObject(
          magasin,
          magasinsSelected,
          Keys.Magasin,
          setMag,
          UrlParams.Magasin
        ),
    ],
    [bannieresSelected, magasinsSelected, updateObject]
  );

  const divisionsChildren = useMemo(
    () => [
      (division: Division) =>
        updateObject(
          division,
          divisionsSelected,
          Keys.Division,
          setDiv,
          UrlParams.Division
        ),
      (newSection: Section) =>
        updateObject(
          newSection,
          sectionsSelected,
          Keys.Section,
          setSection,
          UrlParams.Section
        ),
    ],
    [divisionsSelected, sectionsSelected, updateObject]
  );

  const fournisseursChildren = useMemo(
    () => [
      (fournisseur: Fournisseur) =>
        updateObject(
          fournisseur,
          fournisseursSelected,
          Keys.Fournisseur,
          setFour,
          UrlParams.Fournisseur
        ),
    ],
    [fournisseursSelected, updateObject]
  );
  const statutsChildren = useMemo(
    () => [
      (newStatut: Statut) =>
        updateObject(
          newStatut,
          statutsSelected,
          Keys.Statut,
          setStatut,
          UrlParams.Statut
        ),
    ],
    [statutsSelected, updateObject]
  );
  const activitesChildren = useMemo(
    () => [
      (activite: Activite) =>
        updateObject(
          activite,
          activitesSelected,
          Keys.Activite,
          setCurrentAcc,
          UrlParams.Activite
        ),
    ],
    [activitesSelected, updateObject]
  );
  const collectionsChildren = useMemo(
    () => [
      (collection: Collection) =>
        updateObject(
          collection,
          collectionsSelected,
          Keys.Collection,
          setCollection,
          UrlParams.Collection
        ),
    ],
    [collectionsSelected, updateObject]
  );

  useEffect(() => {
    setProductFields(
      buttonsState.productView
        ? "div_nom,plans_nom"
        : "div_nom,plans_nom,mag_nom"
    );
  }, [buttonsState]);

  useEffect(() => {
    setDataState(initialdataState);
  }, [initialdataState]);

  useEffect(() => {
    if (groupProduit.length > 0) {
      if (activeSection === "" || groupProduit.length === 1) {
        setActiveSection(groupProduit[0].plans_nom);
        setActiveSectionNum(groupProduit[0].plans_seq);
      }
      if (
        (activeMagasin === "" || groupProduit.length === 1) &&
        buttonsState.storeView
      ) {
        setActiveMagasin(groupProduit[0].mag_nom);
        setActiveMagasinNum(groupProduit[0].mag_num);
      }
      const transformedGroupProduit = groupProduit.map((e) => {
        return {
          ...e,
          plano_dt_deb: formatDate(e.plano_dt_deb),
        };
      });
      setDataResult(kendoProcess(transformedGroupProduit, dataState));
    }
  }, [dataState, groupProduit]);

  const handleRech = useCallback(async (value: string) => {
    setRech(value);
  }, []);

  const expandChange = useCallback(
    (event: GridExpandChangeEvent) => {
      if (event.dataIndex !== -1) {
        let i = groupProduit.findIndex(
          (e) => e.prod_num === event.dataItem.prod_num
        );
        dispatch(
          planoAPI.util.updateQueryData(
            "getPlanogramme",
            {
              first: fields,
              mag,
              banniere: ban,
              section,
              four,
              div,
              page: 1,
              rech,
              limite: pageSize,
              acht: user,
              act: currentAcc,
              toSort: toSort,
              order: order,
              statut,
              mode,
              coll: collection,
            },
            (planogramme) => {
              planogramme[i].expanded =
                planogramme[i].expanded === undefined
                  ? true
                  : !planogramme[i].expanded;
              planogramme[i].selected = planogramme[i].selected = false;
              return planogramme;
            }
          )
        );
      } else {
        let groupId = event.dataItem.field + "_" + event.dataItem.value;
        if (!collapsedGroups.includes(groupId)) {
          setCollapsedGroups([...collapsedGroups, groupId]);
        } else {
          setCollapsedGroups(collapsedGroups.filter((gr) => gr !== groupId));
        }
      }
    },
    [
      ban,
      collapsedGroups,
      collection,
      currentAcc,
      dispatch,
      div,
      fields,
      four,
      groupProduit,
      mag,
      mode,
      order,
      pageSize,
      rech,
      section,
      statut,
      toSort,
      user,
    ]
  );

  useEffect(() => {
    let i = groupProduit.findIndex((e) => e.prod_num === parseInt(rech));
    if (i !== -1) {
      dispatch(
        planoAPI.util.updateQueryData(
          "getPlanogramme",
          {
            first: fields,
            mag,
            banniere: ban,
            section,
            four,
            div,
            page: 1,
            rech,
            limite: pageSize,
            acht: user,
            act: currentAcc,
            toSort: toSort,
            order: order,
            statut,
            mode,
            coll: collection,
          },
          (planogramme) => {
            planogramme[i].selected = planogramme[i].selected = true;

            return planogramme;
          }
        )
      );
      if (page === 1) {
        document.querySelector(`[data-grid-row-index="${i}"]`)?.scrollIntoView({
          behavior: "auto",
          block: "center",
        });
      }
    }
  }, [groupProduit]);

  useMemo(() => {
    if (document.querySelector(".k-grid-content") !== null) {
      let gridContainer = document.querySelector(".k-grid-content");
      gridContainer!.scrollTop = 0;
    }
  }, [mag, ban, section, div, user, currentAcc, toSort, order]);

  const handleClick = useCallback(
    (event: GridRowClickEvent) => {
      let i = groupProduit.findIndex(
        (e) => e.prod_num === event.dataItem.prod_num
      );
      if (i !== -1)
        dispatch(
          planoAPI.util.updateQueryData(
            "getPlanogramme",
            {
              first: fields,
              mag,
              banniere: ban,
              section,
              four,
              div,
              page: 1,
              rech,
              limite: pageSize,
              acht: user,
              act: currentAcc,
              toSort: toSort,
              order: order,
              statut,
              mode,
              coll: collection,
            },
            (planogramme) => {
              planogramme.forEach((e) => (e.selected = false));
              planogramme[i].selected = planogramme[i].selected = true;
              return planogramme;
            }
          )
        );
    },
    [
      ban,
      collection,
      currentAcc,
      dispatch,
      div,
      fields,
      four,
      groupProduit,
      mag,
      mode,
      order,
      pageSize,
      rech,
      section,
      statut,
      toSort,
      user,
    ]
  );

  const dataStateChange = async (event: GridDataStateChangeEvent) => {
    setToSort("");
    let groupBy: string | undefined = Array.from(
      new Set(
        event.dataState.group?.map((e) => {
          return e["field"];
        })
      )
    ).join(",");
    if (groupBy === "") {
      localStorage.removeItem("groupBy");
    } else {
      localStorage.setItem("groupBy", groupBy ? groupBy : "");
    }
    let gridContainer = document.querySelector(".k-grid-content");
    gridContainer!.scrollTop = 0;
    setPrev(0);
    setProductFields(groupBy);
    setPage(1);

    const newDataState: State = {
      group: groupBy
        ? groupBy.split(",").map((item) => ({ field: item, dir: undefined }))
        : undefined,
    };
    setDataState(newDataState);
  };

  const isRowInViewport = (rowElement: Element) => {
    const rowRect = rowElement.getBoundingClientRect();
    const tableRect = document
      .getElementsByClassName("k-grid-aria-root")[0]!
      .getBoundingClientRect();

    return rowRect.top >= tableRect.top && rowRect.bottom <= tableRect.bottom;
  };

  const updateActiveSection = useCallback(
    (event: GridEvent) => {
      let rows = event.target!.element!.querySelectorAll(
        ".k-table-row.k-master-row"
      );
      let first: any = "";
      let num: number = 0;
      let magasin: string = "";
      let mag_num: number = 0;

      rows.forEach((e: Element, i: number) => {
        if (isRowInViewport(e) && first === "") {
          if (e.id) {
            let groupe = groupProduit.find(
              (g) => g.prod_num.toString() === e.id
            );
            first = groupe!.plans_nom;
            num = groupe!.plans_seq;
            magasin = groupe?.mag_nom ? groupe?.mag_nom : "";
            mag_num = groupe?.mag_num ? groupe?.mag_num : 0;
          }
          return;
        }
      });

      setActiveSection(first);
      setActiveSectionNum(num);
      if (magasin && mag_num) {
        setActiveMagasin(magasin);
        setActiveMagasinNum(mag_num);
      }
    },
    [groupProduit]
  );

  const scrollHandler = useCallback(
    (event: GridEvent) => {
      if (
        !rech &&
        page < Math.ceil(groupProduit[0]?.nbr_total_grp / pageSize)
      ) {
        updateActiveSection(event);
        if (event.nativeEvent.target.scrollTop > prev) {
          setPrev(event.nativeEvent.target.scrollTop);
          if (isFetching || isLoading) return;

          const e = event.nativeEvent;
          if (
            e.target.scrollTop + 100 >=
            e.target.scrollHeight - e.target.clientHeight
          ) {
            let allTr = document.querySelectorAll(".k-master-row");
            let lastTr = allTr[allTr.length - 1];
            setPage(page + 1);
            lastTr.scrollIntoView(true);
          }
        } else if (
          prev >
          event.nativeEvent.target.scrollHeight -
            event.nativeEvent.target.clientHeight
        ) {
          setPrev(event.nativeEvent.target.scrollTop);
        }
      }
    },
    [
      groupProduit,
      isFetching,
      isLoading,
      page,
      pageSize,
      prev,
      rech,
      updateActiveSection,
    ]
  );

  const handleCloseMod = () => {
    if (modalOpened.length === 0) setAnchorEl(null);
  };

  const handleOpenRemplacePar = async () => {
    setOpenRemplacePar(true);
    const plano = await trigger({
      prod: selectedRow!.toString(),
      statut: "",
      ban: "",
      mag: "",
      manquant: false,
    }).unwrap();
    setListMags(plano.map((e) => e.magasin));
  };

  const handleCloseRemplacePar = () => {
    setOpenRemplacePar(false);
    setListMags([]);
    setAnchorEl(null);
  };

  const handleEditModal = () => {
    setOpenModalEdit(true);
  };
  const handleCloseEditModal = () => {
    if (unsaved) {
      if (window.confirm("Vous avez des modifications non sauvegardé!")) {
        setSelectedRow(null);
        setOpenModalEdit(false);
        setAnchorEl(null);
      } else {
        return;
      }
    }
    setListMags([]);
    setSelectedRow(null);
    setOpenModalEdit(false);
    setAnchorEl(null);
  };

  const handleSort = useCallback(
    (e: any) => {
      if (sortableFields.includes(e.sort[0].field)) {
        if (!fields?.split(",").includes(e.sort[0].field)) {
          if (toSort === "") {
            setOrder(order === "" ? "asc" : "desc");
            setToSort(e.sort[0].field);
          } else if (toSort !== e.sort[0].field) {
            setOrder("asc");
            setToSort(e.sort[0].field);
          } else {
            setOrder(order === "asc" ? "desc" : "");
            setToSort(order === "asc" ? toSort : "");
          }
        } else {
          dispatch(
            addNotificationMessages({
              message: "Impossible de trier un groupBy",
              code: ResponseTypes.WARNING,
              id: Math.random(),
            })
          );
        }
      }
    },
    [dispatch, fields, order, sortableFields, toSort]
  );

  const handleContextMenu = useCallback(
    (event: GridContextMenuEvent) => {
      let i = groupProduit.findIndex(
        (e) => e.prod_num === event.dataItem.prod_num
      );
      if (i !== -1) {
        dispatch(
          planoAPI.util.updateQueryData(
            "getPlanogramme",
            {
              first: fields,
              mag,
              banniere: ban,
              section,
              four,
              statut,
              div,
              page: 1,
              rech,
              limite: pageSize,
              acht: user,
              act: currentAcc,
              toSort: toSort,
              order: order,
              mode,
              coll: collection,
            },
            (planogramme) => {
              planogramme.forEach((e) => (e.selected = false));
              planogramme[i].selected = planogramme[i].selected = true;
            }
          )
        );
        if (event.field) setShowAddMagasinMenu(false);
        setActiveSectionNum(event.dataItem.plans_seq);
        setSelectedRow(event.dataItem.prod_num);
        setAnchorEl(event.nativeEvent.target);
      }
    },
    [
      ban,
      collection,
      currentAcc,
      dispatch,
      div,
      fields,
      four,
      groupProduit,
      mag,
      mode,
      order,
      pageSize,
      rech,
      section,
      statut,
      toSort,
      user,
    ]
  );

  const onContextMenu = useCallback(
    (event: GridContextMenuEvent) => {
      event.nativeEvent.preventDefault();
      handleContextMenu(event);
    },
    [handleContextMenu]
  );

  const HeaderWithTri = useCallback(
    (props: GridHeaderCellProps & { tooltip: string }) => {
      let cols = [
        "div_nom",
        "plans_seq",
        "mod_descr",
        "prod_num",
        "four_nom",
        "act_cd",
        "prod_collection",
        "planost_ventes",
        "planost_ventes_mcx",
      ];

      let tooltipParagraphs: JSX.Element[] = [];

      if (props.tooltip !== undefined) {
        tooltipParagraphs = (props.tooltip || "")
          .split(/(?=\b\w+:)/)
          .map((segment, index) => <p key={index}>{segment.trim()}</p>);
      }

      const isEmptyTooltip =
        tooltipParagraphs.length === 1 &&
        tooltipParagraphs[0].props.children === "";

      return (
        <div className="k-link" onClick={props.onClick}>
          {toSort === props.field &&
            (order === "asc" ? (
              <span className="k-icon k-font-icon k-i-arrow-down" />
            ) : order === "desc" ? (
              <span className="k-icon k-font-icon k-i-arrow-up" />
            ) : (
              <span></span>
            ))}
          {!isEmptyTooltip ? (
            <Tooltip title={tooltipParagraphs}>
              <span>{props.title}</span>
            </Tooltip>
          ) : (
            <span>{props.title}</span>
          )}
          {props.children}
          {props.field !== undefined && cols.includes(props.field) && (
            <Box
              className="k-icon k-font-icon k-i-arrows-swap "
              sx={{ pl: 1 }}
            />
          )}
        </div>
      );
    },
    [order, toSort]
  );

  const handleApplicat = () => {
    let token = localStorage.getItem("token")?.split(" ")[1];
    let user = localStorage.getItem("user");
    window.open(
      process.env.REACT_APP_ENV === "DEV"
        ? `https://publicite-dev.tanguay.ca/#/Inventaire/Produit=${selectedRow}?token=${token}&user=${user}`
        : `https://publicite.tanguay.ca/#/Inventaire/Produit=${selectedRow}?token=${token}&user=${user}`
    );
  };

  const DetailComponentWrapper = useCallback(
    (gridDetailRowProps: GridDetailRowProps) => {
      return (
        <DetailComponent
          prod={gridDetailRowProps.dataItem.prod_num}
          statut={statut}
          ban={ban}
          mag={mag}
          setShowAddMagasin={setShowAddMagasinMenu}
          setListMags={setListMags}
        ></DetailComponent>
      );
    },
    [ban, mag, statut]
  );

  interface BooleanMap {
    [key: string]: boolean;
  }
  const labelConditions: BooleanMap = {
    un_magasin: magasinsSelected.length === 1,
  };

  const gridRows = useMemo(() => {
    var retour =
      groupProduit &&
      headers
        .filter((h) => buttonsState.storeView || h.champ !== "mag_nom")
        .map((item, index) => {
          if (item.affiche_tableau) {
            return (
              <GridColumn
                headerCell={(props) => (
                  <HeaderWithTri {...props} tooltip={item.tooltip!} />
                )}
                field={item.champ}
                key={item.label_champ}
                title={
                  item.label_champ_alt
                    ? labelConditions[item.condition_champ]
                      ? item.label_champ_alt
                      : item.label_champ
                    : item.label_champ
                }
                format={item.format_champ}
                width={item.width}
                headerClassName={`${
                  item.format_champ === "{0:c}" ? "alignRight" : ""
                }`}
                className={`${
                  item.format_champ === "{0:c}" ? "alignRight" : ""
                }`}
              />
            );
          } else {
            return (
              <GridColumn
                field={item.champ}
                key={item.label_champ}
                title={item.label_champ}
                width={0}
                headerClassName={`${
                  item.format_champ === "{0:c}" ? "alignRight" : ""
                }`}
                className={`${
                  item.format_champ === "{0:c}" ? "alignRight" : ""
                }`}
              />
            );
          }
        });

    return retour;
  }, [HeaderWithTri, buttonsState.storeView, groupProduit]);

  const handleGroupState = useCallback(
    (props: any) => {
      return {
        data: mapTree(props.data, "items", (group) => {
          if (!group.aggregates) return group;
          let groupId = group.field + "_" + group.value;
          return { ...group, expanded: !collapsedGroups.includes(groupId) };
        }),
        total: props.total,
      };
    },
    [collapsedGroups]
  );

  const grid = useMemo(() => {
    const toolbar = (
      <Toolbar
        setAddProductTitle={setAddProductTitle}
        setMode={setMode}
        setOpenNewProduit={setOpenNewProduit}
        setSelectedRow={setSelectedRow}
        user={acheteursSelected}
        ban={bannieresSelected}
        mag={magasinsSelected}
        div={divisionsSelected}
        section={sectionsSelected}
        currentAcc={activitesSelected}
        statut={statutsSelected}
        four={fournisseursSelected}
        collection={collectionsSelected}
        setCollection={setCollection}
        setAcheteur={setUser}
        setActivite={setCurrentAcc}
        setBanniere={setBan}
        setDivision={setDiv}
        setFournisseur={setFour}
        setMagasin={setMag}
        setSection={setSection}
        setStatut={setStatut}
        updateObject={updateObject}
      />
    );

    return (
      <GridWrapper>
        {buttonsState.productView ? (
          <CustomGrid
            data={
              groupProduit.length > 0 &&
              (!isError || (isError && (error as APIError).status !== 404))
                ? handleGroupState(dataResult)
                : []
            }
            dataStateChange={dataStateChange}
            detail={DetailComponentWrapper}
            expandChange={expandChange}
            handleClick={handleClick}
            handleSort={handleSort}
            onContextMenu={onContextMenu}
            pageSize={pageSize}
            scrollHandler={scrollHandler}
            dataState={dataState}
            toolbar={toolbar}
            rows={gridRows}
            id="prod_num"
            isPlanoGroupe={true}
          />
        ) : (
          <CustomGrid
            data={
              groupProduit.length > 0 &&
              (!isError || (isError && (error as APIError).status !== 404))
                ? handleGroupState(dataResult)
                : []
            }
            dataStateChange={dataStateChange}
            handleClick={handleClick}
            handleSort={handleSort}
            onContextMenu={onContextMenu}
            pageSize={pageSize}
            scrollHandler={scrollHandler}
            dataState={dataState}
            toolbar={toolbar}
            rows={gridRows}
            id="prod_num"
          />
        )}
      </GridWrapper>
    );
  }, [
    acheteursSelected,
    bannieresSelected,
    magasinsSelected,
    divisionsSelected,
    sectionsSelected,
    activitesSelected,
    statutsSelected,
    fournisseursSelected,
    collectionsSelected,
    updateObject,
    buttonsState.productView,
    groupProduit.length,
    isError,
    error,
    handleGroupState,
    dataResult,
    DetailComponentWrapper,
    expandChange,
    handleClick,
    handleSort,
    onContextMenu,
    pageSize,
    scrollHandler,
    dataState,
    gridRows,
  ]);

  return (
    <div style={{ width: "100%" }}>
      <ClickAwayListener onClickAway={handleCloseMod}>
        <Menu
          id="demo-positioned-menu"
          aria-labelledby="demo-positioned-button"
          anchorEl={anchorEl}
          open={openMod}
          onClose={handleCloseMod}
          anchorOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          disableAutoFocusItem={true}
        >
          <MenuItem disabled={!d_inv170.canRead} onClick={handleApplicat}>
            Inventaire
          </MenuItem>
          <MenuItem onClick={() => setOpenModalStats(true)}>Stats</MenuItem>
          <MenuItem disabled={!d_inv01rp.canModify} onClick={handleEditModal}>
            Modifier
          </MenuItem>
          {!showAddMagasinMenu && (
            <MenuItem
              disabled={!d_inv01rp.canModify}
              onClick={handleOpenRemplacePar}
            >
              Remplacé par
            </MenuItem>
          )}
          {showAddMagasinMenu && (
            <MenuItem
              disabled={!d_inv01rp.canAdd}
              onClick={() => setShowAddMagasin(true)}
            >
              Ajouter le magasin
            </MenuItem>
          )}
          <MenuItem onClick={handleCloseMod}>Annuler</MenuItem>
        </Menu>
      </ClickAwayListener>
      {groupProduit && (
        <Box>
          <GenericModal
            title={`Modification du PTR:  ${padZerosLeft(
              selectedRow!,
              PTR_LENGTH
            )}`}
            open={openModalEdit}
            handleClose={handleCloseEditModal}
            style={getModalStyle}
          >
            <Box>
              <WrapperEditMagasin
                prod={selectedRow}
                setSelectedRow={setSelectedRow}
                setUnsaved={setUnsaved}
                setOpenNewProduit={setOpenNewProduit}
                setOpenModalEdit={setOpenModalEdit}
                setAddProductTitle={setAddProductTitle}
                setListMags={setListMags}
              />
            </Box>
          </GenericModal>
          <GenericModal
            open={open}
            handleClose={handleClose}
            title="Modification de magasins"
            style={getModalStyle}
          >
            <WrapperMagasin
              mag={mag}
              sec={activeSectionNum}
              plans_nom={activeSection}
            />
          </GenericModal>
          <GenericModal
            open={openNewProduit}
            handleClose={handleCloseNewProduit}
            style={getModalStyle}
            title={addProductTitle}
          >
            <FormNewProduit
              row={selectedRow}
              defaultDisabled={true}
              remplaceLe={null}
              showMagList={false}
              listMagsPlano={listMags}
              activeSectionNum={activeSectionNum}
            />
          </GenericModal>
          <GenericModal
            open={openRemplacePar}
            handleClose={handleCloseRemplacePar}
            style={getModalStyle}
            title={"Ajouter un produit"}
          >
            <FormNewProduit
              row={null}
              defaultDisabled={false}
              remplaceLe={selectedRow}
              showMagList={true}
              listMagsPlano={listMags}
              activeSectionNum={activeSectionNum}
            />
          </GenericModal>
          <GenericModal
            open={showAddMagasin}
            handleClose={() => {
              setShowAddMagasin(false);
              setAnchorEl(null);
            }}
            style={getModalStyle}
            title={"Ajouter un magasin"}
          >
            <FormNewProduit
              row={selectedRow}
              defaultDisabled={false}
              remplaceLe={null}
              showMagList={true}
              listMagsPlano={listMags}
              activeSectionNum={activeSectionNum}
            />
          </GenericModal>
          <GenericModal
            open={openModalStats}
            handleClose={handleCloseModalStats}
            title={`Vente collection: ${selectedRow}`}
            style={getModalStyle}
          >
            <StatsModalComponent prod={selectedRow} />
          </GenericModal>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          height: `calc(100vh - ${sizeConfigs.topbar.height})`,
        }}
      >
        {headerExpanded && (
          <Box
            sx={{
              width: sizeConfigs.sidebar.width,
              minHeight: "50px",
              whiteSpace: "nowrap",
              padding: "10px",
            }}
          >
            <HeaderPlano
              user={acheteursSelected}
              ban={bannieresSelected}
              mag={magasinsSelected}
              div={divisionsSelected}
              section={sectionsSelected}
              currentAcc={activitesSelected}
              statut={statutsSelected}
              four={fournisseursSelected}
              handleRech={handleRech}
              setUser={setUser}
              rech={rech}
              sections={sections}
              users={users}
              allBan={bannieres}
              allMag={magasins}
              allDiv={divisions}
              acc={activites}
              statuts={statuts}
              fournisseurs={fournisseurs}
              activitesChildren={activitesChildren}
              bannieresChildren={bannieresChildren}
              divisionsChildren={divisionsChildren}
              fournisseursChildren={fournisseursChildren}
              statutsChildren={statutsChildren}
              allCollections={collections}
              collection={collectionsSelected}
              collectionsChildren={collectionsChildren}
              resetPage={resetPage}
            />
          </Box>
        )}
        <Box
          sx={{
            width: `${
              headerExpanded
                ? `calc(100vw - ${sizeConfigs.sidebar.width})`
                : "100vw"
            }`,
          }}
        >
          {grid}
          {/* {groupProduit.length > 0 && <Footer
            activeSectionNum={activeSectionNum}
            activeSection={activeSection}
            activeMagasin={activeMagasin}
            current={groupProduit.length}
            total={groupProduit[0]?.nbr_total_grp}
            footer={footer}
            handleOpen={() => setOpen(true)}
          />} */}
        </Box>
      </Box>
    </div>
  );
}

export default React.memo(PlanogrammePage);
